import { render, staticRenderFns } from "./HandoverDocumentsDyw.vue?vue&type=template&id=33fbe1f6&scoped=true"
import script from "./HandoverDocumentsDyw.vue?vue&type=script&lang=js"
export * from "./HandoverDocumentsDyw.vue?vue&type=script&lang=js"
import style0 from "./HandoverDocumentsDyw.vue?vue&type=style&index=0&id=33fbe1f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33fbe1f6",
  null
  
)

export default component.exports